'use client';

import Image from 'next/image';
import { useCallback } from 'react';

import { PROMO_BANNER_MAX_WIDTH } from '../../consts';
import { useAdImpression, useTrackAdEvent } from '../../hooks';
import type { AdCampaignDto } from '../../types';
import { fitPromoBannerSize } from '../../utils';

type PromoBannerProps = {
  campaign: AdCampaignDto;
  loading?: 'lazy' | 'eager';
};

export const PromoBanner = ({ campaign, loading = 'lazy' }: PromoBannerProps) => {
  const { trackAdEvent } = useTrackAdEvent();
  const { elementRef } = useAdImpression({
    campaignId: campaign.id,
    enabled: true,
  });

  const mediaUrl = campaign.media.url;
  const isGif = campaign.media.mimeType === 'image/gif';
  const bannerSize = fitPromoBannerSize({
    mediaWidth: campaign.media.width,
    mediaHeight: campaign.media.height,
  });

  const handleClick = useCallback(() => {
    void trackAdEvent(campaign.id, 'click');
  }, [campaign.id, trackAdEvent]);

  if (!mediaUrl || !campaign.promoUrl) {
    return null;
  }

  return (
    <div className="flex w-full justify-center">
      <a
        ref={elementRef}
        href={campaign.promoUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className="inline-block max-w-full overflow-hidden rounded-2xl"
      >
        <Image
          src={mediaUrl}
          alt="Рекламный баннер"
          width={bannerSize.width}
          height={bannerSize.height}
          className="h-auto max-w-full rounded-2xl"
          style={{ width: bannerSize.width }}
          sizes={`(max-width: 640px) 100vw, ${PROMO_BANNER_MAX_WIDTH}px`}
          quality={75}
          loading={loading}
          unoptimized={isGif}
        />
      </a>
    </div>
  );
};
